import { useContext } from "react";
import { AppContext } from "../App";
import { IoMdArrowDropright } from "react-icons/io";

export default function OneService({ image, title, navToLink = {} }) {
	const appContext = useContext(AppContext);

	return (
		<div 
			data-aos="fade-down"
			className="col-md-4 p-2 d-flex"
			style={{ cursor: "pointer" }}
			onClick={() => appContext.navTo(navToLink)}
		>
			<div
				className="rounded bg-light d-flex flex-column w-100 overflow-hidden shadow-sm-hover h-100"
				style={{
					minHeight: "300px", // optional: set reasonable min height
				}}
			>
				{/* Image (rounded top) */}
				<div className="overflow-hidden rounded-top">
					<img 
						src={image} 
						alt={title}
						className="w-100"
						style={{
							objectFit: "cover",
							height: "180px",
						}}
					/>
				</div>

				{/* Content */}
				<div className="d-flex flex-column justify-content-around p-3 flex-grow-1">
					{/* Title (centered, primary) */}
					<h5 className="text-center text-primary fw-bold">{title}</h5>

					{/* Arrow (right-aligned at bottom) */}
					<div className="text-center text-primary">
						<IoMdArrowDropright size={32} />
					</div>
				</div>
			</div>
		</div>
	);
}